<template>
    <div>
        <!-- Modal Reservas -->
        <div class="modal fade" id="reservaEstoqueModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="info">
                    <div class="modal-header">
                        <h5 class="modal-title">Reservas</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            {{ info.st_estoque_item }}
                            <span class="badge badge-info">
                                #{{ info.id_estoque_item }}
                            </span>
                        </div>

                        <az-empty-state v-if="!solics || !solics.length" msg="Nenhuma solicitação encontrada." />
                        
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Paciente</th>
                                    <th>Reservado em</th>
                                    <th>Reservado para</th>
                                    <th>Local</th>
                                    <th>Solicitação</th>
                                    <th class="text-right">Qtde</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(solic, isx) in solics" :key="isx">
                                    <td>{{ solic.marcacao.nome_paciente }}</td>
                                    <td>
                                        <span v-if="solic.marcacao.dt_inicio_atendimento">
                                            {{ $util.getFormatDate(solic.marcacao.dt_inicio_atendimento) }}
                                            {{ solic.marcacao.dt_inicio_atendimento.slice(11,16) }}
                                        </span>
                                    </td>
                                    <td>
                                        {{ $util.getFormatDate(solic.marcacao.dt_inicio) }}
                                        {{ solic.marcacao.dt_inicio.slice(11,16) }}
                                    </td>
                                    <td>
                                        <div v-if="solic.marcacao.unidade_operacao">
                                            {{ solic.marcacao.unidade_operacao.st_sigla ? solic.marcacao.unidade_operacao.st_sigla : solic.marcacao.unidade_operacao.st_nome }}
                                        </div>
                                        <div v-if="solic.local" class="small text-muted">
                                            {{ solic.local.st_estoque_local }}
                                        </div>
                                    </td>
                                    <td>
                                        #{{ solic.id_estoque_solicitacao }}
                                    </td>
                                    <td class="text-right">
                                        <div v-for="(esi, iex) in solic.items" :key="iex">
                                            {{ esi.in_quantidade }}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
  
    data() {
        return { 
            info: null, 
            solics: null, 
        }
    },

    components: { 
        AzEmptyState 
    },
    
    methods: { 
        abrir(lista) { 
            this.solics = null;
            this.info = _.cloneDeep(lista);

            this.$util.load(this, { 
                service: 'estoque', 
                func: 'listar_reservas', 
                parms: { 
                    ids: this.info.reservas.flatMap(r => r.id_marcacoes.split(',')),
                    id_estoque_item: lista.id_estoque_item
                },
                loadTo: res => { 
                    this.solics = res.lista;
                }
            });

            $('#reservaEstoqueModal').modal('show');
        }
    }
}
</script>
